exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-3f3ab1a0] {\n  color: red\n}\n", ""]);

// exports
